import * as React from "react";
import { Box } from "@mui/material";

export interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
  padding?: number;
}

/**
 * Shared tab panel wrapper used across GRN screens.
 * Centralising this avoids redefining the same component in every feature file.
 */
const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  padding = 2,
}) => {
  if (value !== index) {
    return null;
  }

  return <Box sx={{ p: padding }}>{children}</Box>;
};

export default TabPanel;
